import { useNavigate } from 'react-router-dom';
import { isIntercomEnabled, showIntercomMessenger } from '@/lib/intercom';

/** Support fallback route when Intercom isn't configured (mirrors `useCtaRouter`'s `openIntercom` action). */
const SUPPORT_FALLBACK_ROUTE = '/settings';

/**
 * "Contact Support" action for the KYC rejected / on-hold pop-ups: opens the
 * Intercom messenger when configured, otherwise falls back to the Settings
 * support surface — the same contract as the notifications pop-up CTA router
 * (`useCtaRouter`'s `openIntercom` case). `showIntercomMessenger` swallows
 * failures and no-ops when disabled, so this never dead-ends. Does not close
 * the KYC gate — contacting support is a non-destructive side action, not a
 * dismiss.
 */
export function useKycSupportAction(): () => void {
  const navigate = useNavigate();
  return () => {
    if (isIntercomEnabled()) showIntercomMessenger();
    else navigate(SUPPORT_FALLBACK_ROUTE);
  };
}
